import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';

import {
  getMarginStyles,
  IconWrapper,
  TooltipContainer,
  tooltipStyles,
} from './styles';
import { CustomTooltipProps } from './types';
import TooltipDefaultIcon from '../../../assets/icons/TooltipDefaultIcon';
import { formatTooltipText } from '../../../helpers/formatTooltipText';

export const CustomTooltip: React.FC<CustomTooltipProps> = ({
  text,
  icon,
  showIcon = true,
  placement = 'right-start',
  children,
  asyncLoadText,
}) => {
  const [tooltipText, setTooltipText] = useState(formatTooltipText(text));
  const tooltipContent =
    children ||
    (showIcon ? (
      <IconWrapper>{icon || <TooltipDefaultIcon />}</IconWrapper>
    ) : (
      <span />
    ));

  const onTooltipOpen = () => {
    if (asyncLoadText) {
      asyncLoadText()
        .then((t) => {
          setTooltipText(formatTooltipText(t));
        })
        .catch(console.error);
    }
  };

  return (
    <TooltipContainer>
      <Tooltip
        title={tooltipText}
        placement={placement}
        onOpen={onTooltipOpen}
        componentsProps={{
          tooltip: {
            sx: {
              ...tooltipStyles.tooltip,
              ...getMarginStyles(placement),
              whiteSpace: 'pre-line',
            },
          },
        }}
      >
        {tooltipContent}
      </Tooltip>
    </TooltipContainer>
  );
};
